import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const heTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'שם (אותיות קטנות, ללא תווים מיוחדים)',
    add: 'הוסף',
    allowedFileTypes: 'סוגי קבצים מותרים',
    allowedFileTypesDescription:
      'הגבל סוגי קבצים מותרים (למשל, image/*, application/pdf). השאר ריק כדי לאפשר את כל הסוגים.',
    allowMultipleFiles: 'אפשר מספר קבצים',
    amountInCents: 'סכום בסנטים',
    basePrice: 'מחיר בסיס',
    bcc: 'BCC',
    brand: 'מותג',
    cc: 'CC',
    checkboxPlural: 'שדות תיבת סימון',
    checkboxSingular: 'תיבת סימון',
    checkedByDefault: 'מסומן כברירת מחדל',
    chooseConfirmationType: 'בחר אם להציג הודעה בדף או להפנות מחדש לדף אחר לאחר שליחת הטופס.',
    condition: 'מצב',
    confirmationMessage: 'הודעת אישור',
    confirmationType: 'סוג אישור',
    countryPlural: 'שדות ארץ',
    countrySingular: 'מדינה',
    creditCard: 'כרטיס אשראי',
    customURL: 'כתובת אתר מותאמת אישית',
    datePlural: 'שדות תאריך',
    dateSingular: 'תאריך',
    defaultValue: 'ערך ברירת מחדל',
    divide: 'לחלק',
    documentToLinkTo: 'מסמך לקישור',
    doesNotEqual: 'לא שווה',
    emailFrom: 'דוא"ל מאת',
    emailPlural: 'שדות דוא"ל',
    emailsDescription:
      'שלח אימיילים מותאמים אישית כאשר הטופס נשלח. השתמש ברשימות מופרדות בפסיקים כדי לשלוח את אותו דוא"ל למספר נמענים. כדי להפנות לערך מהטופס הזה, עטוף את שם השדה בסוגריים מסולסלים כפולים, כלומר {{firstName}}. אתה יכול להשתמש בתו כללי {{*}} כדי להוציא את כל הנתונים ו-{{*:table}} כדי לעצב אותם כטבלת HTML בדוא"ל.',
    emailSingular: 'דוא"ל',
    emailTo: 'דוא"ל אל',
    equals: 'שווה',
    field: 'שדה',
    fields: 'שדות',
    fieldWidth: 'רוחב שדה (אחוז)',
    hasAnyValue: 'יש ערך כלשהו',
    internalLink: 'קישור פנימי',
    label: 'תווית',
    maxFileSize: 'גודל קובץ מקסימלי (בתים)',
    maxFileSizeDescription: 'גודל קובץ מקסימלי בבתים. השאר ריק ללא הגבלה.',
    message: 'הודעה',
    messageDescription: 'הזן את ההודעה שאמורה להישלח בדוא"ל זה.',
    messagePlural: 'חסימות הודעות',
    messageSingular: 'הודעה',
    mimeType: 'סוג MIME',
    mimeTypePlural: 'סוגי MIME',
    mimeTypeSingular: 'סוג MIME',
    multiply: 'תכפילו',
    numberPlural: 'שדות מספר',
    numberSingular: 'מספר',
    optionPlural: 'אפשרויות',
    optionSingular: 'אפשרות',
    paymentFieldPlural: 'שדות תשלום',
    paymentFieldSingular: 'תשלום',
    paymentProcessor: 'מעבד תשלומים',
    paymentStatus: 'סטטוס',
    placeholder: 'מציין מקום',
    priceConditions: 'תנאי מחיר',
    priceConditionsPlural: 'תנאי מחיר',
    priceConditionsSingular: 'מצב מחיר',
    radioOptions: 'אפשרויות תכונת רדיו',
    radioPlural: 'שדות רדיו',
    radioSingular: 'רדיו',
    redirect: 'הפניה מחדש',
    replyTo: 'השב ל',
    required: 'חובה',
    selectOptions: 'בחר אפשרויות',
    selectPlural: 'בחר שדות',
    selectSingular: 'בחר',
    statePlural: 'שדות המדינה',
    stateSingular: 'מדינה',
    staticValue: 'ערך סטטי',
    subject: 'נושא',
    submitButton: 'שלח תווית לחצן',
    subtract: 'להחסיר',
    textareaPlural: 'שדות טקסט',
    textareaSingular: 'Textarea',
    textPlural: 'שדות טקסט',
    textSingular: 'טקסט',
    title: 'כותרת',
    token: 'אסימון',
    uploadCollection: 'העלה אוסף',
    uploadCollectionDescription: 'בחר באיזה אוסף העלאה לאחסן קבצים',
    uploadFieldPlural: 'העלאת שדות',
    uploadFieldSingular: 'העלה',
    urlToRedirectTo: 'כתובת אתר להפניה מחדש',
    value: 'ערך',
    valueOfField: 'ערך השדה',
    valueType: 'סוג ערך',
  },
}

export const he: PluginLanguage = {
  dateFNSKey: 'he',
  translations: heTranslations,
}
